import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet-async";

import LockIcon from "src/assets/large_lock_icon.svg";
import { Iconify } from "src/components/Iconify";
import { useNavigateAuthenticatedUserToHomePage } from "src/hooks/useNavigateAuthenticatedUserToHomePage";
import RoutedButton from "src/newComponents/buttons/RoutedButton";

import { AuthPageTemplate } from "../AuthPageTemplate";
import { ResetPasswordForm } from "./ResetPasswordForm";

const ForgotPasswordPage = () => {
  useNavigateAuthenticatedUserToHomePage();

  return (
    <>
      <Helmet link={[{ rel: "canonical", href: "/forgot-password/" }]}>
        <title>Forgot Password | Pre-Reg Shortcuts</title>
        <meta
          name="description"
          content="Reset your Pre-Reg Shortcuts password securely. Regain access to your online pharmacy training."
        />
        <meta
          name="keywords"
          content="Reset Password, Recover Account, Access Revision plan, Enter email address, Receive link to reset password"
        />
      </Helmet>
      <AuthPageTemplate title="Forgot Password" icon={{ src: LockIcon, alt: "Forgot Password" }}>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
          Please enter your email address associated and we will email you a link to reset your password.
        </Typography>

        <ResetPasswordForm />

        <RoutedButton
          path="/login/"
          buttonColor="inherit"
          size="medium"
          variant="text"
          buttonStyle={{ marginTop: "1rem" }}
        >
          <Iconify icon="carbon:chevron-left" width={16} sx={{ mr: 1 }} />
          Return to sign in
        </RoutedButton>
      </AuthPageTemplate>
    </>
  );
};

export default ForgotPasswordPage;
